import React from "react";
// import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "./scss/main.scss";
import { store, persistor } from "./Store";
import App from "./App";
import { createRoot } from "react-dom/client";
// import setUpAxios from "./Services/Axios";
// import axios from "axios";
import { PersistGate } from "redux-persist/integration/react";
import moment from "moment";
import "moment-timezone";

moment.locale('en', {
  week: {
    dow: 1,
    doy: 1,
  },
});

const localTz = moment.tz.guess();

moment.tz.setDefault(localTz)

// For React 18
// https://reactjs.org/blog/2022/03/08/react-18-upgrade-guide.html#updates-to-client-rendering-apis
// setUpAxios(axios);
const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={<div>Loading...</div>}>
      <App />
    </PersistGate>
  </Provider>
);
